import * as Sentry from "@sentry/browser";

export function captureException(err) {
  if (process.env.NODE_ENV === "production") {
    Sentry.captureException(err);
  } else {
    console.error(err);
  }
}
